<div class="modal-container">
    <div class="modal-header">
        <h4>{{ 'INFORMATE_HEADER.BUTTONS_TEXT.EXPORT_REPORTS_OPTIONS.CREATEJCC' | transloco }}</h4>
        <a class="close-icon" href="javascript:void()" ngbAutofocus><i (click)="closeModal()" class="flaticon2-cross"></i></a>
    </div>
    <form [formGroup]="jointCompletionForm" *ngIf="jointCompletionForm">
        <div class="modal-body output-lable section-scroll">
            <div class="row">
                <div class="col-md-6">
                    <div class="row">
                        <div class="col-md-5" style="padding: 15px">
                            <mat-label class="font-style">{{ 'INFORMATE_HEADER.JCC.CUSTOMER' | transloco }}</mat-label>
                        </div>
                        <div class="col-md-6">
                            <mat-form-field class="example-full-width custom-text-field">
                                <input
                                    type="text"
                                    matInput
                                    placeholder="{{ 'INFORMATE_HEADER.JCC.CUSTOMER' | transloco }}"
                                    formControlName="customer"
                                    name="customer"
                                />
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-5" style="padding: 15px">
                            <mat-label class="font-style">{{ 'INFORMATE_HEADER.JCC.PROJECT_NUMBER' | transloco }}</mat-label>
                        </div>
                        <div class="col-md-6">
                            <mat-form-field class="example-full-width custom-text-field">
                                <input
                                    type="text"
                                    matInput
                                    placeholder="{{ 'INFORMATE_HEADER.JCC.PROJECT_NUMBER' | transloco }}"
                                    formControlName="projectNumber"
                                    name="project_number"
                                />
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-5" style="padding: 15px">
                            <mat-label class="font-style">{{ 'INFORMATE_HEADER.JCC.JOINT_ID' | transloco }}</mat-label>
                        </div>
                        <div class="col-md-6">
                            <mat-form-field class="example-full-width custom-text-field">
                                <input
                                    type="text"
                                    matInput
                                    placeholder="{{ 'INFORMATE_HEADER.JCC.JOINT_ID' | transloco }}"
                                    formControlName="joint_id"
                                    name="joint_id"
                                />
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-5" style="padding: 15px">
                            <mat-label class="font-style">{{ 'INFORMATE_HEADER.JCC.VESSEL_REF' | transloco }}</mat-label>
                        </div>
                        <div class="col-md-6">
                            <mat-form-field class="example-full-width custom-text-field">
                                <input
                                    type="text"
                                    matInput
                                    placeholder="{{ 'INFORMATE_HEADER.JCC.VESSEL_REF' | transloco }}"
                                    formControlName="vessel_ref"
                                    name="vessel_ref"
                                />
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-5" style="padding: 15px">
                            <mat-label class="font-style">{{ 'INFORMATE_HEADER.JCC.PERMANENT_TAG' | transloco }}</mat-label>
                        </div>
                        <div class="col-md-6">
                            <mat-form-field class="example-full-width custom-text-field">
                                <input
                                    type="text"
                                    matInput
                                    placeholder="{{ 'INFORMATE_HEADER.JCC.PERMANENT_TAG' | transloco }}"
                                    formControlName="permanent_tag"
                                    name="permanent_tag"
                                />
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-5" style="padding: 15px">
                            <mat-label class="font-style">{{ 'INFORMATE_HEADER.JCC.PID_NUMBER' | transloco }}</mat-label>
                        </div>
                        <div class="col-md-6">
                            <mat-form-field class="example-full-width custom-text-field">
                                <input
                                    type="text"
                                    matInput
                                    placeholder="{{ 'INFORMATE_HEADER.JCC.PID_NUMBER' | transloco }}"
                                    formControlName="pid_number"
                                    name="pid_number"
                                />
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-5" style="padding: 15px">
                            <mat-label class="font-style">{{ 'INFORMATE_HEADER.JCC.BOLT_COATING' | transloco }}</mat-label>
                        </div>
                        <div class="col-md-6">
                            <mat-form-field class="example-full-width custom-text-field">
                                <input
                                    type="text"
                                    matInput
                                    placeholder="{{ 'INFORMATE_HEADER.JCC.BOLT_COATING' | transloco }}"
                                    formControlName="bolt_coating"
                                    name="bolt_coating"
                                />
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-5" style="padding: 15px">
                            <mat-label class="font-style">{{ 'INFORMATE_HEADER.JCC.TOOL_SERIAL_NO' | transloco }}</mat-label>
                        </div>
                        <div class="col-md-6">
                            <mat-form-field class="example-full-width custom-text-field">
                                <input
                                    type="text"
                                    matInput
                                    placeholder="{{ 'INFORMATE_HEADER.JCC.TOOL_SERIAL_NO' | transloco }}"
                                    formControlName="tool_serial_no"
                                    name="gasket_filter"
                                />
                            </mat-form-field>
                        </div>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="row">
                        <div class="col-md-5" style="padding: 15px">
                            <mat-label class="font-style">{{ 'INFORMATE_HEADER.JCC.SITE' | transloco }}</mat-label>
                        </div>
                        <div class="col-md-6">
                            <mat-form-field class="example-full-width custom-text-field">
                                <input type="text" matInput placeholder="{{ 'INFORMATE_HEADER.JCC.SITE' | transloco }}" formControlName="site" name="site" />
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-5" style="padding: 15px">
                            <mat-label class="font-style">{{ 'INFORMATE_HEADER.JCC.PROJECT_NAME' | transloco }}</mat-label>
                        </div>
                        <div class="col-md-6">
                            <mat-form-field class="example-full-width custom-text-field">
                                <input
                                    type="text"
                                    matInput
                                    placeholder="{{ 'INFORMATE_HEADER.JCC.PROJECT_NAME' | transloco }}"
                                    formControlName="project_name"
                                    name="project_name"
                                />
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-5" style="padding: 15px">
                            <mat-label class="font-style">{{ 'INFORMATE_HEADER.JCC.JOINT_LOCATION' | transloco }}</mat-label>
                        </div>
                        <div class="col-md-6">
                            <mat-form-field class="example-full-width custom-text-field">
                                <input
                                    type="text"
                                    matInput
                                    placeholder="{{ 'INFORMATE_HEADER.JCC.JOINT_LOCATION' | transloco }}"
                                    formControlName="joint_location"
                                    name="joint_location"
                                />
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-5" style="padding: 15px">
                            <mat-label class="font-style">{{ 'INFORMATE_HEADER.JCC.WORK_PACK' | transloco }}</mat-label>
                        </div>
                        <div class="col-md-6">
                            <mat-form-field class="example-full-width custom-text-field">
                                <input
                                    type="text"
                                    matInput
                                    placeholder="{{ 'INFORMATE_HEADER.JCC.WORK_PACK' | transloco }}"
                                    formControlName="work_pack"
                                    name="work_pack"
                                />
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-5" style="padding: 15px">
                            <mat-label class="font-style">{{ 'INFORMATE_HEADER.JCC.LINE_NUMBER' | transloco }} </mat-label>
                        </div>
                        <div class="col-md-6">
                            <mat-form-field class="example-full-width custom-text-field">
                                <input
                                    type="text"
                                    matInput
                                    placeholder="{{ 'INFORMATE_HEADER.JCC.LINE_NUMBER' | transloco }}"
                                    formControlName="line_number"
                                    name="line_number "
                                />
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-5" style="padding: 15px">
                            <mat-label class="font-style">{{ 'INFORMATE_HEADER.JCC.ISO_NUMBER' | transloco }}</mat-label>
                        </div>
                        <div class="col-md-6">
                            <mat-form-field class="example-full-width custom-text-field">
                                <input
                                    type="text"
                                    matInput
                                    placeholder="{{ 'INFORMATE_HEADER.JCC.ISO_NUMBER' | transloco }}"
                                    formControlName="iso_number"
                                    name="iso_number"
                                />
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-5" style="padding: 15px">
                            <mat-label class="font-style">{{ 'INFORMATE_HEADER.JCC.GASKET_FILTER' | transloco }}</mat-label>
                        </div>
                        <div class="col-md-6">
                            <mat-form-field class="example-full-width custom-text-field">
                                <input
                                    type="text"
                                    matInput
                                    placeholder="{{ 'INFORMATE_HEADER.JCC.GASKET_FILTER' | transloco }}"
                                    formControlName="gasket_filter"
                                    name="gasket_filter"
                                />
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-5" style="padding: 15px">
                            <mat-label class="font-style">{{ 'INFORMATE_HEADER.JCC.PUMP/GAUGE_SERIAL_NO' | transloco }}</mat-label>
                        </div>
                        <div class="col-md-6">
                            <mat-form-field class="example-full-width custom-text-field">
                                <input
                                    type="text"
                                    matInput
                                    placeholder="{{ 'INFORMATE_HEADER.JCC.PUMP/GAUGE_SERIAL_NO' | transloco }}"
                                    formControlName="pump_gauge_serial_no"
                                    name="gasket_filter"
                                />
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-md-3" style="padding: 15px">
                            <mat-label class="font-style">{{ 'INFORMATE_HEADER.JCC.REFERENCE_DOCUMENT' | transloco }}</mat-label>
                        </div>
                        <div class="col-md-9">
                            <mat-form-field class="example-full-width custom-text-field">
                                <input
                                    type="text"
                                    matInput
                                    placeholder="{{ 'INFORMATE_HEADER.JCC.REFERENCE_DOCUMENT' | transloco }}"
                                    formControlName="reference_document"
                                    name="reference_document"
                                />
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-4">
                    <div class="row">
                        <div class="col-md-6" style="padding: 15px">
                            <mat-label class="font-style">{{ 'INFORMATE_HEADER.JCC.INSTRUCTED_BY' | transloco }}</mat-label>
                        </div>
                        <div class="col-md-6">
                            <mat-form-field class="example-full-width custom-text-field">
                                <input
                                    type="text"
                                    matInput
                                    placeholder="{{ 'INFORMATE_HEADER.JCC.INSTRUCTED_BY' | transloco }}"
                                    formControlName="instructed_by"
                                    name="instructed_by"
                                />
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="row">
                        <div class="col-md-5" style="padding: 15px">
                            <mat-label class="font-style">{{ 'INFORMATE_HEADER.JCC.COMPANY' | transloco }}</mat-label>
                        </div>
                        <div class="col-md-7">
                            <mat-form-field class="example-full-width custom-text-field">
                                <input
                                    type="text"
                                    matInput
                                    placeholder="{{ 'INFORMATE_HEADER.JCC.COMPANY' | transloco }}"
                                    formControlName="instructed_company"
                                    name="company"
                                />
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="row">
                        <div class="col-md-5" style="padding: 15px">
                            <mat-label class="font-style">{{ 'INFORMATE_HEADER.JCC.POSITION' | transloco }}</mat-label>
                        </div>
                        <div class="col-md-7">
                            <mat-form-field class="example-full-width custom-text-field">
                                <input
                                    type="text"
                                    matInput
                                    placeholder="{{ 'INFORMATE_HEADER.JCC.POSITION' | transloco }}"
                                    formControlName="instructed_position"
                                    name="position"
                                />
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-4">
                    <div class="row">
                        <div class="col-md-6" style="padding: 15px">
                            <mat-label class="font-style">{{ 'INFORMATE_HEADER.JCC.ASSEMBLED_BY' | transloco }}</mat-label>
                        </div>
                        <div class="col-md-6">
                            <mat-form-field class="example-full-width custom-text-field">
                                <input
                                    type="text"
                                    matInput
                                    placeholder="{{ 'INFORMATE_HEADER.JCC.ASSEMBLED_BY' | transloco }}"
                                    formControlName="assembled_by"
                                    name="assembled_by"
                                />
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="row">
                        <div class="col-md-5" style="padding: 15px">
                            <mat-label class="font-style">{{ 'INFORMATE_HEADER.JCC.COMPANY' | transloco }}</mat-label>
                        </div>
                        <div class="col-md-7">
                            <mat-form-field class="example-full-width custom-text-field">
                                <input
                                    type="text"
                                    matInput
                                    placeholder="{{ 'INFORMATE_HEADER.JCC.COMPANY' | transloco }}"
                                    formControlName="assembled_company"
                                    name="company"
                                />
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="row">
                        <div class="col-md-5" style="padding: 15px">
                            <mat-label class="font-style">{{ 'INFORMATE_HEADER.JCC.DATE' | transloco }}</mat-label>
                        </div>
                        <div class="col-md-7">
                            <dx-date-box
                                class="dx-date-custom-wrapper"
                                displayFormat="dd-MMM-yyyy"
                                [inputAttr]="{ 'aria-label': 'Choose Date' }"
                                formControlName="assembled_date"
                                placeholder="{{ 'INFORMATE_HEADER.JCC.DATE' | transloco }}"
                                blockDateTyping
                            >
                            </dx-date-box>
                            <!-- Added 'blockDateTyping' directive to block typing  in dx-datepicker -->
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-4">
                    <div class="row">
                        <div class="col-md-6" style="padding: 15px">
                            <mat-label class="font-style">{{ 'INFORMATE_HEADER.JCC.TIGTHEN_BY_1' | transloco }}</mat-label>
                        </div>
                        <!-- <div class="col-md-6">
                            <dx-date-box
                                class="dx-date-custom-wrapper"
                                displayFormat="dd-MMM-yyyy"
                                [inputAttr]="{ 'aria-label': 'Choose Date' }"
                                formControlName="tightened_by_one"
                                placeholder="{{ 'INFORMATE_HEADER.JCC.TIGTHEN_BY_1' | transloco }}"
                                blockDateTyping
                            >
                            </dx-date-box>
                         </div> -->
                        <div class="col-md-6">
                            <mat-form-field class="example-full-width custom-text-field">
                                <input
                                    type="text"
                                    matInput
                                    placeholder="{{ 'INFORMATE_HEADER.JCC.TIGTHEN_BY_1' | transloco }}"
                                    formControlName="tightened_by_one"
                                />
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="row">
                        <div class="col-md-5" style="padding: 15px">
                            <mat-label class="font-style">{{ 'INFORMATE_HEADER.JCC.COMPANY' | transloco }}</mat-label>
                        </div>
                        <div class="col-md-7">
                            <mat-form-field class="example-full-width custom-text-field">
                                <input
                                    type="text"
                                    matInput
                                    placeholder="{{ 'INFORMATE_HEADER.JCC.COMPANY' | transloco }}"
                                    formControlName="tightened_by_one_company"
                                    name="tightened_by_one"
                                />
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="row">
                        <div class="col-md-5" style="padding: 15px">
                            <mat-label class="font-style">{{ 'INFORMATE_HEADER.JCC.DATE' | transloco }}</mat-label>
                        </div>
                        <div class="col-md-7">
                            <dx-date-box
                                class="dx-date-custom-wrapper"
                                displayFormat="dd-MMM-yyyy"
                                [inputAttr]="{ 'aria-label': 'Choose Date' }"
                                formControlName="tightened_by_one_date"
                                placeholder="{{ 'INFORMATE_HEADER.JCC.DATE' | transloco }}"
                                blockDateTyping
                            >
                            </dx-date-box>
                            <!-- Added 'blockDateTyping' directive to block typing  in dx-datepicker -->
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-4">
                    <div class="row">
                        <div class="col-md-6" style="padding: 15px">
                            <mat-label class="font-style">{{ 'INFORMATE_HEADER.JCC.TIGTHEN_BY_2' | transloco }}</mat-label>
                        </div>
                        <div class="col-md-6">
                            <mat-form-field class="example-full-width custom-text-field">
                                <input
                                    type="text"
                                    matInput
                                    placeholder="{{ 'INFORMATE_HEADER.JCC.TIGTHEN_BY_2' | transloco }}"
                                    formControlName="tightened_by_two"
                                    name="tightened_by_two"
                                />
                            </mat-form-field>
                        </div>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="row">
                        <div class="col-md-5" style="padding: 15px">
                            <mat-label class="font-style">{{ 'INFORMATE_HEADER.JCC.COMPANY' | transloco }}</mat-label>
                        </div>
                        <div class="col-md-7">
                            <mat-form-field class="example-full-width custom-text-field">
                                <input
                                    type="text"
                                    matInput
                                    placeholder="{{ 'INFORMATE_HEADER.JCC.COMPANY' | transloco }}"
                                    formControlName="tightened_by_two_company"
                                />
                            </mat-form-field>
                        </div>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="row">
                        <div class="col-md-5" style="padding: 15px">
                            <mat-label class="font-style">{{ 'INFORMATE_HEADER.JCC.DATE' | transloco }}</mat-label>
                        </div>
                        <div class="col-md-7">
                            <dx-date-box
                                class="dx-date-custom-wrapper"
                                displayFormat="dd-MMM-yyyy"
                                [inputAttr]="{ 'aria-label': 'Choose Date' }"
                                formControlName="tightened_by_two_date"
                                placeholder="Date"
                                blockDateTyping
                            >
                            </dx-date-box>
                            <!-- Added 'blockDateTyping' directive to block typing  in dx-datepicker -->
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-8">
                    <div class="row">
                        <div class="col-md-3" style="padding: 15px">
                            <mat-label class="font-style">{{ 'INFORMATE_HEADER.JCC.REPORT_COMPLETED_BY' | transloco }}</mat-label>
                        </div>
                        <div class="col-md-9">
                            <mat-form-field class="example-full-width custom-text-field">
                                <input
                                    type="text"
                                    matInput
                                    placeholder="{{ 'INFORMATE_HEADER.JCC.REPORT_COMPLETED_BY' | transloco }}"
                                    formControlName="report_completed"
                                    name="report_completed"
                                />
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="row">
                        <div class="col-md-5" style="padding: 15px">
                            <mat-label class="font-style">{{ 'INFORMATE_HEADER.JCC.DATE' | transloco }}</mat-label>
                        </div>
                        <div class="col-md-7">
                            <dx-date-box
                                class="dx-date-custom-wrapper"
                                displayFormat="dd-MMM-yyyy"
                                [inputAttr]="{ 'aria-label': 'Choose Date' }"
                                formControlName="report_completed_date"
                                placeholder="{{ 'INFORMATE_HEADER.JCC.DATE' | transloco }}"
                                blockDateTyping
                            >
                            </dx-date-box>
                            <!-- Added 'blockDateTyping' directive to block typing  in dx-datepicker -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <div class="row">
                        <div class="col-md-6" style="padding: 15px">
                            <mat-label class="font-style">{{ 'INFORMATE_HEADER.JCC.CUSTOMER_ACCEPTENCE' | transloco }}</mat-label>
                        </div>
                        <div class="col-md-6">
                            <mat-form-field class="example-full-width custom-text-field">
                                <input
                                    type="text"
                                    matInput
                                    placeholder="{{ 'INFORMATE_HEADER.JCC.CUSTOMER_ACCEPTENCE' | transloco }}"
                                    formControlName="customer_acceptance"
                                    name="customer_acceptance"
                                />
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="row">
                        <div class="col-md-5" style="padding: 15px">
                            <mat-label class="font-style">{{ 'INFORMATE_HEADER.JCC.COMPANY' | transloco }}</mat-label>
                        </div>
                        <div class="col-md-7">
                            <mat-form-field class="example-full-width custom-text-field">
                                <input
                                    type="text"
                                    matInput
                                    placeholder="{{ 'INFORMATE_HEADER.JCC.COMPANY' | transloco }}"
                                    formControlName="customer_acceptance_company"
                                    name="company"
                                />
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="row">
                        <div class="col-md-5" style="padding: 15px">
                            <mat-label class="font-style">{{ 'INFORMATE_HEADER.JCC.DATE' | transloco }}</mat-label>
                        </div>
                        <div class="col-md-7">
                            <dx-date-box
                                class="dx-date-custom-wrapper"
                                displayFormat="dd-MMM-yyyy"
                                [inputAttr]="{ 'aria-label': 'Choose Date' }"
                                formControlName="customer_acceptance_date"
                                placeholder="{{ 'INFORMATE_HEADER.JCC.DATE' | transloco }}"
                                blockDateTyping
                            >
                            </dx-date-box>
                            <!-- Added 'blockDateTyping' directive to block typing  in dx-datepicker -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-md-2" style="padding: 15px">
                            <mat-label class="font-style">{{ 'INFORMATE_HEADER.JCC.COMMENTS' | transloco }}</mat-label>
                        </div>
                        <div class="col-md-10">
                            <mat-form-field class="example-full-width custom-text-field">
                                <textarea
                                    rows="3"
                                    type="text"
                                    formControlName="comments"
                                    matInput
                                    placeholder="{{ 'INFORMATE_HEADER.JCC.COMMENTS' | transloco }}"
                                    name="comments"
                                >
                                </textarea>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <div class="modal-footer">
        <button type="button" class="btn primary-ebtn" (click)="continueButtonClick()">
            {{ 'INFORMATE_HEADER.DATASHEET_REPORT.BUTTONS.CONTINUE' | transloco }}
        </button>
        <button type="button" class="btn secondary-ebtn" (click)="closeModal()">
            {{ 'INFORMATE_HEADER.DATASHEET_REPORT.BUTTONS.CANCLE' | transloco }}
        </button>
    </div>
</div>
